<script>
import { h } from "vue";
import { Link } from '@inertiajs/vue3'
export default {
    name: "AlbumCard",
    props: {
        album: {
            type: Object,
            default: {},
        },
    },
    render() {
        return h(
            'div',
            {class: 'w-full'},
            h(Link, {href: '/album/' + this.album.id, 'class': 'group block rounded-2xl p-2 transition-colors hover:bg-white/[0.04] focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent'}, () => [
                h('div', {class: 'aspect-square w-full overflow-hidden rounded-xl bg-nomad-800 ring-1 ring-white/[0.08]'},
                    h('img', {src: this.album.cover, alt: this.album.name, loading: 'lazy', class: 'h-full w-full object-cover transition-transform duration-500 group-hover:scale-105'})),
                h('h3', { class: 'mt-3 truncate text-[0.9375rem] font-semibold text-white'}, this.album.name),
                h('h4', {class: 'text-sm text-nomad-400'}, this.album.released_at)
            ])
        );
    },
};
</script>
